import { NextPageContext } from 'next'
import Cookies, { CookieGetOptions } from 'universal-cookie'

/**
 * forked from next-cookies
 */
export function nextCookieHandler(
    ctx: NextPageContext,
    options?: CookieGetOptions,
) {
    // Note: Next.js Static export sets
    // ctx.req to a fake request with no headers
    const header = ctx.req && ctx.req.headers && ctx.req.headers.cookie
    const uc = new Cookies(header)
    return uc.getAll(options)
}
